import React from "react";
import PropTypes from "prop-types";
import { List } from "immutable";
import {
    KanBanContainer,
    KanBanColumn,
    KanBanCardItem,
    LoaderSkeleton
} from "components";
import { CASE_VIEW_ACTION } from "constants";
import store from "store";
import { getDefaultCaseLandingTab } from "constants/user-visibility";

class KanBanParticipated extends React.Component {
    viewCaseDetails = (caseId, caseName, companyId) => {
        const { history, location } = this.props;
        let stages = this.props.stages.map(_ => _.id);
        const landingTab = !stages.includes(9) ? "case_details" : getDefaultCaseLandingTab(store.getState().user);
        history.push(
            `/app/${
                window.location.pathname.split("/")[2]
            }/${caseId}/${landingTab}`,
            {
                ...location.state,
                case_details: {
                    companyId,
                    case: caseId,
                    action: CASE_VIEW_ACTION,
                    name: caseName,
                    tabId: landingTab
                }
            }
        );
    };
    // state = {
    //     selected: new Map({})
    // };
    // handleItemCheck = (stageId, caseId, checked) => {
    //     const { selected } = this.state;
    //     this.setState({
    //         selected: selected.set(`${stageId}-${caseId}`, checked)
    //     });
    // };

    render() {
        const { isDataFetched, stages, cases, caseCount } = this.props;
        // const { selected } = this.state;
        return (
            <LoaderSkeleton loading={!isDataFetched}>
                <KanBanContainer>
                    {(stages || new List([]))
                        .map(_ => (
                            <KanBanColumn
                                key={_.stage_name}
                                title={_.stage_name}
                                fetch={this.props.fetch.bind(
                                    null,
                                    _.stage_name,
                                    _.id
                                )}
                                status={cases.getIn([_.stage_name, "status"])}
                                count={caseCount.get(_.stage_name)}
                                fetchedCount={
                                    cases.getIn([_.stage_name, "data"]).size
                                }
                            >
                                {cases
                                    .getIn([_.stage_name, "data"])
                                    .map(__ => (
                                        <KanBanCardItem
                                            key={__.id}
                                            id={__.id}
                                            companyId={__.company.id}
                                            stageId={_.id}
                                            title={__.getCompanyName()}
                                            aging={__.task_aging}
                                            list={__.getList()}
                                            tags={[
                                                {
                                                    color: "#87d068",
                                                    value: __.task_user
                                                },
                                                {
                                                    color: "#87d068",
                                                    value: __.case_delegation
                                                }
                                            ]}
                                            onClick={this.viewCaseDetails}
                                        />
                                    ))
                                    .toList()
                                    .toArray()}
                            </KanBanColumn>
                        ))
                        .toList()
                        .toArray()}
                </KanBanContainer>
            </LoaderSkeleton>
        );
    }
}

KanBanParticipated.defaultProps = {
    stages: new List([])
};

KanBanParticipated.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    isDataFetched: PropTypes.bool,
    stages: PropTypes.object,
    cases: PropTypes.object,
    caseCount: PropTypes.object,
    fetch: PropTypes.func
};

export default KanBanParticipated;
